<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/N2DvzI/tc-custom/9781504057677.jpg?1736614245814" alt="This image is the cover for the book Miss Silver Mysteries Volume Five, The Miss Silver Mysteries"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Miss Silver Mysteries Volume Five, The Miss Silver Mysteries
      </h1>
      <p class="bookDescription body article font2">
        <b>The British governess-turned-sleuth continues her witty, inquisitive ways with three mysteries from the “timelessly charming” series (Charlotte MacLeod).</b><br/><br/> Retired governess Maud Silver has discovered an entirely new calling: private detection. And though she may seem an unlikely sleuth, Scotland Yard needs her more than ever in this charming series from “a first-rate storyteller” (<i>The Daily Telegraph</i>).<br/>  <br/><i>The Case of William Smith</i>: William Smith isn’t sure what his name is, but he knows it isn’t William Smith. That was the name the Nazis gave him in 1942, when he was sent to die in one of their nightmarish camps. Now the war is over and he’s back in England, ready to start over. But even a man with no past can’t escape history. And if Miss Silver can figure out his true identity, his enemies are going to finish what they started.<br/>  <br/><i>Eternity Ring</i>: Det. Sgt. Frank Abbot thought he’d spend a quiet holiday at his family’s estate. Instead, he hears wild tales of a man dragging a murdered girl into the woods. Naturally, he calls his friend, Miss Maud Silver, to take a look. But when no one can locate the body of the rumored victim and the sole witness suffers a broken neck, the only thing Miss Silver knows for sure is that the pastoral peace of this town masks something far more sinister.<br/>  <br/><i>The Catherine Wheel</i>: When a wealthy man named Taverner places a newspaper ad looking for distant relatives to add to his will, several possible relations appear from all over England. But with the scent of money in the air, old feuds reemerge and the extended family squabbles over the cash. It’s not long before there is one less Taverner, and Miss Silver is called in to find out who put the knife in his back.<br/>  <br/> These charming British mysteries featuring the unstoppable Miss Silver—whose stout figure, fondness for Tennyson, and passion for knitting belie a keen intellect and a knack for cracking even the toughest cases—are sure to delight readers of Agatha Christie, Ellis Peters, and Dorothy L. Sayers.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Patricia  Wentworth
      </h2>
      
      <p class="authorDescription body article">Patricia Wentworth (1878&ndash;1961) was one of the masters of classic English mystery writing. Born in India as Dora Amy Elles, she began writing after the death of her first husband, publishing her first novel in 1910. In the 1920s, she introduced the character who would make her famous: Miss Maud Silver, the former governess whose stout figure, fondness for Tennyson, and passion for knitting served to disguise a keen intellect. Along with Agatha Christie&rsquo;s Miss Marple, Miss Silver is the definitive embodiment of the English style of cozy mysteries.<BR></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Open Road Integrated Media
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?224508ac